import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import estilos from '../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css'
import EditIcon from '@mui/icons-material/Edit';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import 'react-notifications-component/dist/theme.css';

import { useContext } from 'react';
import { getInspectores } from '../../../../redux/DucksUnidadInspeccion/InspectoresDuck';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const styleMotivo = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function InformacionGeneralFormComponent(props) {

    const dispatch = useDispatch();

    const inspectores = useSelector(store => store.Inspectores.inspectores);

    const dataUser = props.inspectorLogeado;

    const colorVerde = 'rgb(208, 236, 231)';
    const colorAmarillo = 'rgb(249, 231, 159)';

    const [noaplica, setNoaplica] = React.useState(true);
    const [validar, setValidar] = React.useState({
        validar: false,
        index: -1
    });
    const [openModalResponsable, setOpenModalRespobsable] = React.useState(false);
    const [openModalTestigo, setOpenModalTestigo] = React.useState(false);
    const [openModalTestigoMotivo, setOpenModalTestigoMotivo] = React.useState(false);
    const [editarResponsable, setEditarResponsable] = React.useState(true);
    const [inspectorOculto, setinspectorOculto] = React.useState(true);
    
    const [responsables, setResponsables] = React.useState([]);
    const [ineResponsable, setIneResponsable] = React.useState([]);
    const [ineTestigo, setIneTestigo] = React.useState([]);
    const [inspector, setInspector] = React.useState();
    const [tutor, setTutor] = React.useState("");
    const [testigos, setTestigos] = React.useState([]);
    const [isContext, setIsContext] = React.useState(false);
    const [motivo, setMotivo] = React.useState('')

    
    const fecha = Date.now();
    const hoy = new Date(fecha);

    const formatoFecha = () => {
        let anio = hoy.getFullYear();
        let mes = hoy.getMonth() + 1;
        let dia = hoy.getDate();

        dia = ('0' + dia).slice(-2);
        mes = ('0' + mes).slice(-2);

        return anio + "-" + mes + "-" + dia;
    }

    const formatoHora = () => {
        var hora = hoy.getHours();
        var minuto = hoy.getMinutes();
        var segundo = hoy.getSeconds();
        if (hora < 10) hora = "0" + hora;
        if (minuto < 10) minuto = "0" + minuto;
        if (segundo < 10) segundo = "0" + segundo;

        return hora + ":" + minuto + ":" + segundo;
    }


    var fechaHoy = formatoFecha();
    var horaACtual = formatoHora();

    const [informacionFormik, setInformacionFormik] = React.useState(
        {
            solicitud: props.informe.fi_25_caratula[0].solicitud,
            informe: props.informe.fi_25_caratula[0].ninforme,
            escrito: props.informe.fi_25_caratula[0].ncomision,
            fecha: fechaHoy,
            hora: horaACtual,
            razon: props.solicitud.nombrerazonsocial,
            tipo: props.informe.fi_25_anexo[0].tipoanexo.descripcion,
            inspectorseleccionado: props.informe.fi_25_caratula[0].idinspector,
            edad: '',
            telefono: '',
            email: '',
            responsables: responsables,
            testigos: testigos
        }

    );


    React.useEffect(() => {
        dispatch(getInspectores())   //inspectores
    }, []);

    React.useEffect(() => {
        console.log(props.informe);
        setResponsables(props.informe.fi_25_caratula[0].fi_25_responsables);
        setTestigos(props.informe.fi_25_caratula[0].fi_25_testigos)
        setInspector(props.informe.fi_25_caratula[0].inspector)        
    }, [props.informe]);

    useEffect(() => {
        setInformacionFormik({
            ...informacionFormik,
            responsables: responsables
        })
    }, [responsables])

    useEffect(() => {
        // setContextTestigos(testigos)
    }, [testigos])

    useEffect(() => {
        tutor
    }, [tutor])

    useEffect(() => {
        true
    }, [inspectorOculto])

    useEffect(() => {
        inspector
    }, [inspector])

    useEffect(() => {
        inspectores
    }, [inspectores])


    const handleOpenModalResponsable = () => {
        setOpenModalRespobsable(true);
    }
    const handleCloseModalRespobsable = () => {
        setOpenModalRespobsable(false);
    }

    const handleOpenModalTestigo = () => {
        setOpenModalTestigo(true);
    }
    const handleCloseModalTestigo = () => {
        setOpenModalTestigo(false);
    }

    const handleOpenModalTestigoMotivo = () => {
        setOpenModalTestigoMotivo(true);
        setTestigos([])
    }
    const handleCloseModalTestigoMotivo = () => {
        setOpenModalTestigoMotivo(false);
    }

    const handleNuevoTestigo = (valores) => {
        setTestigos([...testigos,
        {
            testigo: valores.testigo,
            ineFrontal: ineTestigo[0],
            inePosterior: ineTestigo[1],
        }])
        setIneTestigo([])
        handleCloseModalTestigo();
    }

    const handleNuevoResponsable = (valores) => {
        setResponsables([...responsables,
        {
            correoelectronico: valores.correoelectronico,
            edad: valores.edad,
            email: valores.email,
            nombreresponsable: valores.nombreresponsable,
            responsable: valores.responsable,
            telefono: valores.telefono,
            ineFrontal: ineResponsable[0],
            inePosterior: ineResponsable[1],
        }])
        setIneResponsable([])
        handleCloseModalRespobsable();

    }

    const handleEditarResponsable = () => {
        setEditarResponsable(!editarResponsable);
    }

    const handleIneResponsable = (event) => {
        if (event.target.files[0] != undefined) {
            setIneResponsable([...ineResponsable, event.target.files[0]]);
        }
    }

    const handleIneTestigo = (event) => {
        if (event.target.files[0] != undefined) {
            setIneTestigo([...ineTestigo, event.target.files[0]]);
        }
    }

    const handleEliminarResponsable = (elemento) => {
        let responsable = responsables.filter((r) => r !== elemento);
        setResponsables(responsable);
    }

    const handleEliminarTestigo = (elemento) => {
        let testigo = testigos.filter((t) => t !== elemento);
        setTestigos(testigo);
    }

    useEffect(() => {
        validar
    }, [validar])

    const handleValidar = (index) => {
        const tr = document.getElementById('responsable' + index)
        tr.style.backgroundColor === colorVerde ? tr.style.backgroundColor = 'white' : tr.style.backgroundColor = colorVerde
    }


    const handleMostrarAvisoEditable = (index) => {
        const tr = document.getElementById('responsable' + index)
        const icon = document.getElementById('responsableIcon' + index)
        tr.style.backgroundColor === colorAmarillo ? tr.style.backgroundColor = 'white' : tr.style.backgroundColor = colorAmarillo
        icon.style.display === 'none' ? icon.style.display = 'inline' : icon.style.display = 'none'
    }

    const modalComponentResponsable = () => {
        return (
            <div>
                <Modal
                    open={openModalResponsable}
                    onClose={handleCloseModalRespobsable}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Responsable
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={{
                                    responsable: '',
                                    edad: '',
                                    telefono: '',
                                    email: ''
                                }}
                                enableReinitialize
                                validate={(valores) => {
                                    let errores = {};

                                    if (!valores.nombreresponsable) {
                                        errores.nombreresponsable = 'Por favor ingresa el nombre del responsable'
                                    }

                                    if (!valores.edad) {
                                        errores.edad = 'Por favor ingresa una edad'
                                    }

                                    if (!valores.telefono) {
                                        errores.telefono = 'Por favor ingresa un telefono'
                                    }

                                    if (!valores.correoelectronico) {
                                        errores.correoelectronico = 'Por favor ingresa un correo electronico'
                                    }

                                    return errores;
                                }}
                                onSubmit={(valores) => {
                                    handleNuevoResponsable(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='row'>
                                            <div className="col-md-4 mb-3">
                                                <label htmlFor="responsable">Responsable de las Instalaciones</label>
                                                <Field type="text" className="form-control form-control-sm" id="nombreresponsable" name="nombreresponsable" placeholder="Responsable de las Instalaciones" required></Field>
                                                <ErrorMessage name='nombreresponsable' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.nombreresponsable}</div>
                                                )} />
                                            </div>
                                            <div className="col-md-1 mb-3">
                                                <label htmlFor="edad">Edad</label>
                                                <Field type="number" className="form-control form-control-sm" id="edad" name="edad" placeholder="0" required></Field>
                                                <ErrorMessage name='edad' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.edad}</div>
                                                )} />
                                            </div>
                                            <div className="col mb-3">
                                                <label htmlFor="telefono">Telefono</label>
                                                <Field type="phone" className="form-control form-control-sm" id="telefono" name="telefono" placeholder="Telefono" required></Field>
                                                <ErrorMessage name='telefono' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.telefono}</div>
                                                )} />
                                            </div>
                                            <div className="col mb-3">
                                                <label htmlFor="email">Correo Electronico</label>
                                                <Field type="email" className="form-control form-control-sm" id="correoelectronico" name="correoelectronico" placeholder="Correo Electronico" required></Field>
                                                <ErrorMessage name='correoelectronico' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.correoelectronico}</div>
                                                )} />
                                            </div>
                                            <div className="col-md-3 mb-3">

                                                <label htmlFor="anexarine1">INE: Parte Frontal</label>
                                                <Field type="file" className="form-control form-control-sm" id="anexarine" name="anexarine" placeholder="" multiple={false} required accept="image/png,image/jpeg" onChange={handleIneResponsable}></Field>
                                                <ErrorMessage name='anexarine' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.anexarine}</div>
                                                )} />
                                                <hr />
                                                <label htmlFor="anexarine1">INE: Parte Trasera</label>
                                                <Field type="file" className="form-control form-control-sm" id="anexarine" name="anexarine" placeholder="" multiple={false} required accept="image/png,image/jpeg" onChange={handleIneResponsable}></Field>
                                                <ErrorMessage name='anexarine' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.anexarine}</div>
                                                )} />

                                            </div>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const handleSeleccionarInspector = (event) => {
        let inspectorSeleccionado = inspectores.filter(i => i.idinspector == event.target.value)

        setInspector(inspectorSeleccionado[0])

        if (inspectorSeleccionado[0].idcatalogopuestos == 3) {
            setinspectorOculto(false)
            let t = inspectores.filter(i => i.idinspector == inspectorSeleccionado[0].tutor)
            setTutor(t[0].idinspector)
        } else {
            setinspectorOculto(true)
            setTutor(null);
        }
    }

    const handleSeleccionarTutor = (event) => {
        let inspectorSeleccionado = inspectores.filter(i => i.idinspector == event.target.value)
        setTutor(inspectorSeleccionado[0].idinspector)
    }

    const modalComponentTestigo = () => {
        return (
            <div>
                <Modal
                    open={openModalTestigo}
                    onClose={handleCloseModalTestigo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Testigo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={{
                                    testigo: ''
                                }}
                                validate={(valores) => {
                                    let errores = {};

                                    if (!valores.testigo) {
                                        errores.testigo = 'Por favor ingresa el nombre del testigo'
                                    }


                                    return errores;
                                }}
                                onSubmit={(valores) => {
                                    handleNuevoTestigo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='row'>
                                            <div className="col-md-9 mb-3">
                                                <label htmlFor="testigo1">Testigo</label>
                                                <Field type="text" className="form-control form-control-sm" id="testigo" name="testigo" placeholder="Testigo" required></Field>
                                                <ErrorMessage name='testigo' component={() => (
                                                    <div className={`${estilos.error}`}>{props.errors.testigo}</div>
                                                )} />
                                            </div>
                                            <div className="col-md-3 mb-3">

                                                <label htmlFor="anexarine1">INE: Parte Frontal</label>
                                                <Field type="file" className="form-control form-control-sm" id="anexarine" name="anexarine" placeholder="" multiple={false} required accept="image/png,image/jpeg" onChange={handleIneTestigo}></Field>

                                                <hr />
                                                <label htmlFor="anexarine1">INE: Parte Trasera</label>
                                                <Field type="file" className="form-control form-control-sm" id="anexarine" name="anexarine" placeholder="" multiple={false} required accept="image/png,image/jpeg" onChange={handleIneTestigo}></Field>


                                            </div>

                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>

                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    const modalComponentTestigoMotivo = () => {
        return (
            <div>
                <Modal
                    open={openModalTestigoMotivo}
                    onClose={handleCloseModalTestigoMotivo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleMotivo}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Motivo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={{
                                    motivo: motivo
                                }}
                                validate={(valores) => {
                                    let errores = {};

                                    // if (!valores.motivo) {
                                    //     errores.motivo = 'Ingrese el motivo'
                                    // }

                                    return errores;
                                }}
                                onSubmit={(valores) => {
                                    setMotivo(valores.motivo);
                                    handleCloseModalTestigoMotivo();
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className="row">
                                            <div className="col">
                                                <h5>¿Porque no existen testigos?</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <Field type="text" as="textarea" className="form-control form-control-sm" name='motivo' />
                                            <ErrorMessage name='motivo' component={() => (
                                                <div className={`${estilos.error}`}>{props.errors.motivo}</div>
                                            )} />
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <div className="col">
                                                <br />
                                                <button type='submit' className="btn btn-success" >GUARDAR</button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>

                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <Formik
                initialValues={informacionFormik}
                enableReinitialize={true}
                validate={(valores) => {
                    let errores = {};

                    if (!valores.escrito) {
                        errores.escrito = 'Por favor ingresa un Numero de Escrito'
                    }

                    if (!valores.fecha) {
                        errores.fecha = 'Por favor ingresa una fecha'
                    }

                    if (!valores.hora) {
                        errores.hora = 'Por favor ingresa una hora'
                    }

                    if (!valores.informe) {
                        errores.informe = 'Por favor ingresa un Numero de Informe'
                    }

                    if (!valores.razon) {
                        errores.razon = 'Por favor ingresa una Razon Social'
                    }

                    if (!valores.solicitud) {
                        errores.solicitud = 'Por favor ingresa un Numero de Solicitud'
                    }


                    if (!valores.tipo) {
                        errores.tipo = 'Por favor ingresa un Tipo de Instalacion'
                    }

                    return errores;
                }}
                onSubmit={(valores) => {

                }}
            >
                {(props) => (
                    <Form>
                        <br></br>
                        <div className={`row text-center ${estilos.tabsSegundoNivel} ${estilos.seccionUI}`}>
                            <div id="caratula FI-25" className={`row mb-6 ${estilos.seccion}`}>
                                <div className="row mb-6">
                                    <div className="col-md-2 mb-3 ">
                                        <label htmlFor="solicitud">Solicitud</label>
                                        <Field type="text" className="form-control form-control-sm" id="solicitud" name="solicitud" placeholder="Solicitud" required></Field>
                                        <ErrorMessage name='solicitud' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.solicitud}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="informe">N° de Informe</label>
                                        <Field type="text" className="form-control form-control-sm" id="informe" name="informe" placeholder="N° de Informe" required></Field>
                                        <ErrorMessage name='informe' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.informe}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="escrito">N° de comisión</label>
                                        <Field type="text" className="form-control form-control-sm" id="escrito" name="escrito" placeholder="N° de escrito de comisión" required></Field>
                                        <ErrorMessage name='escrito' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.escrito}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="hora">Hora</label>
                                        <Field type="time" className="form-control form-control-sm" id="hora" name="hora" placeholder="Hora de Actividad" disabled required></Field>
                                        <ErrorMessage name='hora' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.hora}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="fecha">Fecha</label>
                                        <Field type="text" className="form-control form-control-sm" id="fecha" name="fecha" placeholder="Fecha de Actividad" disabled required></Field>
                                        <ErrorMessage name='fecha' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.fecha}</div>
                                        )} />
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="razon">Empresa/Razón Social</label>
                                        <Field type="text" className="form-control form-control-sm" id="razon" name="razon" placeholder="Razon social" required></Field>
                                        <ErrorMessage name='razon' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.razon}</div>
                                        )} />
                                    </div>
                                    <div className="col-md-2 mb-3">
                                        <label htmlFor="tipo">Tipo</label>
                                        <Field type="text" className="form-control form-control-sm" id="tipo" name="tipo" placeholder="Tipo" required></Field>
                                        <ErrorMessage name='tipo' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.tipo}</div>
                                        )} />
                                    </div>
                                    {//<div className="col-md-4 mb-3">
                                        //  <label htmlFor="inspector">Inspector</label>
                                        //<Field disabled type="text" className="form-control form-control-sm" id="inspector" name="inspector" placeholder="Inspector" required value={dataUser[0].usuario}></Field>
                                        //</div>
                                    }

                                    <div className="col-md-4 mb-3">
                                        <label>Inspector</label>
                                        <Field
                                            component="select"
                                            id="inspectorseleccionado"
                                            name="inspectorseleccionado"

                                            className="form-select"
                                            multiple={false}
                                            onChange={handleSeleccionarInspector}
                                            required

                                        >
                                            <option defaultValue>Seleccione Inspector</option>
                                            {inspectores.map((inspector, index) => {
                                                return (
                                                    <option key={index} value={inspector.idinspector}>{inspector.titulo + " " + inspector.nombre + " " + inspector.apellidos}</option>

                                                )


                                            })}
                                        </Field>
                                        <ErrorMessage name='inspectorseleccionado' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.inspectorseleccionado}</div>
                                        )} />
                                        <hr hidden={inspectorOculto} />
                                        <label hidden={inspectorOculto}>Tutor</label>
                                        <Field
                                            component="select"
                                            id="inspectorseleccionado2"
                                            name="inspectorseleccionado2"

                                            className="form-select"
                                            multiple={false}
                                            onChange={handleSeleccionarTutor}
                                            hidden={inspectorOculto}

                                        >
                                            <option defaultValue>Seleccione Inspector Acreditado</option>
                                            {inspectores.map((inspector, index) => {
                                                if (inspector.idcatalogopuestos != 3) {
                                                    return (
                                                        <option key={index} value={inspector.idinspector}>{inspector.titulo + " " + inspector.nombre + " " + inspector.apellidos}</option>

                                                    )
                                                }

                                            })}
                                        </Field>
                                        <ErrorMessage name='inspectorseleccionado2' component={() => (
                                            <div className={`${estilos.error}`}>{props.errors.inspectorseleccionado2}</div>
                                        )} />
                                    </div>

                                </div>
                            </div>
                            <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                <label className={`${estilos.labelUI} mb-2`}>RESPONSABLE DE INSTALACIÓN</label>
                            </div>
                            <div className='table-responsive'>
                                <table className='table table-striped table-hover'>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Responsable</th>
                                            <th width="70">Edad</th>
                                            <th width="130">Telefono</th>
                                            <th>Correo Electronico</th>
                                            <th>Acciones</th>
                                            <th>Validar</th>
                                        </tr>
                                    </thead>
                                    <FieldArray
                                        name='responsables'
                                        render={arrayHelpers => (
                                            <tbody>
                                                {responsables &&
                                                    responsables.map((responsable, index) => (
                                                        <tr key={index} id={'responsable' + index}>
                                                            <td><EditIcon id={'responsableIcon' + index} style={{ display: 'none' }} /></td>
                                                            <td><Field type="text" className="form-control form-control-sm" id="responsable" name={`responsables.${index}.nombre`} placeholder="Responsable de las Instalaciones" required></Field>
                                                                <ErrorMessage name='responsable' component={() => (
                                                                    <div className={`${estilos.error}`}>{props.errors.responsable}</div>
                                                                )} />
                                                            </td>
                                                            <td><Field type="number" className="form-control form-control-sm" id="edad" name={`responsables.${index}.edad`} placeholder="0" required></Field>
                                                                <ErrorMessage name='edad' component={() => (
                                                                    <div className={`${estilos.error}`}>{props.errors.edad}</div>
                                                                )} />
                                                            </td>
                                                            <td><Field type="phone" className="form-control form-control-sm" id="telefono" name={`responsables.${index}.telefono`} placeholder="" required></Field>
                                                                <ErrorMessage name='telefono' component={() => (
                                                                    <div className={`${estilos.error}`}>{props.errors.telefono}</div>
                                                                )} />
                                                            </td>
                                                            <td><Field type="email" className="form-control form-control-sm" id="correoelectronico" name={`responsables.${index}.correoelectronico`} placeholder="" required></Field>
                                                                <ErrorMessage name='email' component={() => (
                                                                    <div className={`${estilos.error}`}>{props.errors.email}</div>
                                                                )} />
                                                            </td>
                                                            <td>
                                                                <button type="button" className='btn btn-warning btn-sm' onClick={() => handleMostrarAvisoEditable(index)}><EditIcon /></button>
                                                                <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarResponsable(responsable)}><DeleteForeverIcon /></button>
                                                            </td>
                                                            <td>
                                                                <button type="button" className='btn btn-success btn-sm' onClick={() => handleValidar(index)}><CheckCircleIcon /></button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        )}
                                    />
                                </table>
                            </div>

                            <div style={{ textAlign: "center" }}>
                                <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalResponsable}>+</button>
                            </div>

                            <div id="caratula FI-25" className={`row mb-6 mt-3 ${estilos.seccion}`}>
                                <label className={`${estilos.labelUI} mb-2`}>TESTIGOS</label>
                            </div>
                            <div className="row">
                                <div className="col mb-3 ">
                                    <Field className="form-check-input" type="checkbox" checked={motivo ? true : false} onClick={handleOpenModalTestigoMotivo} name="noaplica" id="noaplica" />
                                    <label className="form-check-label" htmlFor="noaplica">
                                        NO APLICA
                                    </label>
                                </div>
                            </div>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Nombre</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='testigos'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {testigos.map((testigo, index) => {
                                                return (
                                                    <tr key={index} id={'testigo' + index}>
                                                        <td></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="testigo" name={`testigos.${index}.testigo`} placeholder="Testigo" value={testigo.testigo} required></Field></td>
                                                        <td>
                                                            <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarTestigo(testigo)}><DeleteForeverIcon /></button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    )}
                                />
                            </table>
                            {//testigos.map((testigo, index) => {
                                //   return (
                                //       <div key={index} className='table-responsive'>
                                //           <table className='table table-striped table-hover'>
                                //               <thead>
                                //                   <tr>
                                //                       <th>Nombre del Testigo</th>
                                //                       <th>Acciones</th>
                                //                   </tr>
                                //               </thead>
                                //               <tbody>
                                //                   <tr>
                                //                       <td><Field type="text" className="form-control form-control-sm" id="testigo" name="testigo" placeholder="Nombre del testigo" required readOnly={true} value={testigo.testigo}></Field>
                                //                           <ErrorMessage name='responsable' component={() => (
                                //                               <div className={`${estilos.error}`}>{props.errors.testigo}</div>
                                //                           )} />
                                //                       </td>
                                //                       <td>
                                //                           <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarTestigo(testigo)}>Eliminar</button>
                                //                       </td>
                                //                   </tr>
                                //               </tbody>
                                //           </table>
                                //       </div>
                                //   )
                                //})
                            }
                            <div style={{ textAlign: "center" }} >
                                <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalTestigo}>+</button>
                            </div>

                            <br></br>


                            <br></br>

                        </div>
                        {
                            //<div className="row">
                            //    <div className="col ">
                            //        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            //    </div>
                            //
                            //</div>
                        }
                        <br />
                    </Form>
                )}
            </Formik>
            <div>
                {modalComponentResponsable()}
            </div>

            <div>
                {modalComponentTestigo()}
            </div>

            <div>
                {modalComponentTestigoMotivo()}
            </div>
        </Fragment>
    );
};


export default withRouter(InformacionGeneralFormComponent)
